import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getOrdersForSubsite = createAsyncThunk('orders/getOrdersForSubsite', async (params) => {
  console.log("PARAMS", params);
    try {
        let url = process.env.REACT_APP_API_URL + "/admin/orders?range=[" + params[1] + "," + params[2] + "]&filter=" + params[0];
        
        if (params[4]) {
          url += "&showNHK=" + params[4];
        }

        // Add search parameter if provided
        if (params[3] && params[3].trim() !== '') {
          url += "&search=" + encodeURIComponent(params[3]);
        }

        const response = await axios.get(url, { headers: AuthHeader.authHeader()});
        return {data: response.data, count: response.headers["total-items"]};
    } catch (error) {
        console.log(error);
    }
  });

  export const getSuperAdminOrders = createAsyncThunk('orders/getSuperAdminOrders', async (params) => {
    console.log("SUPER ADMIN PARAMS", params);
    try {
        let url = process.env.REACT_APP_API_URL + "/admin/super/orders?range=[" + params[1] + "," + params[2] + "]&filter=" + params[0];

        // Add search parameter if provided
        if (params[3] && params[3].trim() !== '') {
          url += "&search=" + encodeURIComponent(params[3]);
        }

        const response = await axios.get(url, { headers: AuthHeader.authHeader()});
        return {data: response.data, count: response.headers["total-items"]};
    } catch (error) {
        console.log(error);
    }
  });

  export const cancelOrder = createAsyncThunk('orders/cancelOrder', async (orderId) => {
    try {
        const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/order/cancel/" + orderId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const reopenOrder = createAsyncThunk('orders/reopenOrder', async (orderId) => {
    try {
        const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/order/reopen/" + orderId, {}, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
  });

  export const approveOrder = createAsyncThunk('orders/approveOrder', async (orderId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/order/approve/" + orderId, { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }
  });

  export const removeOrderItemAdmin = createAsyncThunk('orders/removeOrderItemAdmin', async (itemId) => {
    const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/orderitem/" + itemId, { headers: AuthHeader.authHeader()});
    return response.data;
  });

  export const addOrderShipment = createAsyncThunk('orders/addOrderShipment', async ({ orderId, shippingDate, trackingNumber, shipped }) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/admin/super/order/" + orderId + "/shipment",
      { shippingDate, trackingNumber, shipped },
      { headers: AuthHeader.authHeader() }
    );
    return { orderId, shipment: response.data.data };
  });

  export const updateOrderShipment = createAsyncThunk('orders/updateOrderShipment', async ({ shipmentId, orderId, shippingDate, trackingNumber, shipped }) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + "/admin/super/order/shipment/" + shipmentId,
      { shippingDate, trackingNumber, shipped },
      { headers: AuthHeader.authHeader() }
    );
    return { orderId, shipment: response.data.data };
  });

  export const deleteOrderShipment = createAsyncThunk('orders/deleteOrderShipment', async ({ shipmentId, orderId }) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/admin/super/order/shipment/" + shipmentId,
      { headers: AuthHeader.authHeader() }
    );
    return { orderId, shipmentId: response.data.shipmentId || shipmentId };
  });

  export const uploadTrackingCsv = createAsyncThunk('orders/uploadTrackingCsv', async ({ file, shippingDate }) => {
    const data = new FormData();
    data.append('file', file, file.name);
    if (shippingDate) {
      data.append('shippingDate', shippingDate);
    }
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/admin/super/orders/tracking/upload",
      data,
      { headers: AuthHeader.authHeader() }
    );
    return response.data;
  });

  export const allOrders = state => state.orders.orders;
  export const orderCount = state => state.orders.orderCount;
  export const trackingUploadStatus = state => state.orders.trackingUploadStatus;
  export const trackingUploadResults = state => state.orders.trackingUploadResults;
  export const trackingUploadError = state => state.orders.trackingUploadError;

  const initialState = {
    orders: [],
    orderCount: 0,
    approveStatus: 'idle',
    cancelStatus: 'idle',
    removeItemStatus: 'idle',
    shipmentStatus: 'idle',
    trackingUploadStatus: 'idle',
    trackingUploadResults: null,
    trackingUploadError: null,
    status: 'idle',
    error: null
  };

  const ordersSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
      clearTrackingUpload(state) {
        state.trackingUploadStatus = 'idle';
        state.trackingUploadResults = null;
        state.trackingUploadError = null;
      }
    },
    extraReducers(builder) {
        builder
          .addCase(getOrdersForSubsite.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getOrdersForSubsite.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.orders = action.payload.data;
            state.orderCount = action.payload.count;
          })
          .addCase(getOrdersForSubsite.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(cancelOrder.pending, (state, action) => {
            state.cancelStatus = 'loading'
          })
          .addCase(cancelOrder.fulfilled, (state, action) => {
            state.cancelStatus = 'succeeded';
            var idxToRemove = -1;
            for(var i=0; i<state.orders.length; i++) {
              if(state.orders[i].id === action.payload.orderId) {
                idxToRemove = i;
                break;
              }
            }
            state.orders.splice(idxToRemove, 1);
            state.status = 'idle';
          })
          .addCase(cancelOrder.rejected, (state, action) => {
            state.cancelStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(reopenOrder.pending, (state, action) => {
            state.reopenStatus = 'loading'
          })
          .addCase(reopenOrder.fulfilled, (state, action) => {
            state.reopenStatus = 'succeeded';
            var idxToRemove = -1;
            for(var i=0; i<state.orders.length; i++) {
              if(state.orders[i].id === action.payload.orderId) {
                idxToRemove = i;
                break;
              }
            }
            if (idxToRemove >= 0) {
              state.orders.splice(idxToRemove, 1);
            }
            state.status = 'idle';
          })
          .addCase(reopenOrder.rejected, (state, action) => {
            state.reopenStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(approveOrder.pending, (state, action) => {
            state.approveStatus = 'loading'
          })
          .addCase(approveOrder.fulfilled, (state, action) => {
            state.approveStatus = 'succeeded';
            state.status = 'idle';
            var idxToRemove = -1;
            for(var i=0; i<state.orders.length; i++) {
              if(state.orders[i].id === action.payload.orderId) {
                idxToRemove = i;
                break;
              }
            }
            state.orders.splice(idxToRemove, 1);
            console.log(action.payload);
          })
          .addCase(approveOrder.rejected, (state, action) => {
            state.approveStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(getSuperAdminOrders.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getSuperAdminOrders.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.orders = action.payload.data;
            state.orderCount = action.payload.count;
          })
          .addCase(getSuperAdminOrders.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(removeOrderItemAdmin.pending, (state, action) => {
            state.removeItemStatus = 'loading';
          })
          .addCase(removeOrderItemAdmin.fulfilled, (state, action) => {
            state.removeItemStatus = 'succeeded';
            const { itemId, orderId } = action.payload || {};
            if (!itemId || !orderId) return;
            for (var i = 0; i < state.orders.length; i++) {
              if (state.orders[i].id === orderId) {
                state.orders[i].order_items = state.orders[i].order_items.filter(it => it.id !== itemId);
                break;
              }
            }
          })
          .addCase(removeOrderItemAdmin.rejected, (state, action) => {
            state.removeItemStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(addOrderShipment.pending, (state) => {
            state.shipmentStatus = 'loading';
          })
          .addCase(addOrderShipment.fulfilled, (state, action) => {
            state.shipmentStatus = 'succeeded';
            const { orderId, shipment } = action.payload || {};
            if (!orderId || !shipment) return;
            for (var i = 0; i < state.orders.length; i++) {
              if (state.orders[i].id === orderId) {
                if (!state.orders[i].order_shipments) {
                  state.orders[i].order_shipments = [];
                }
                state.orders[i].order_shipments.push(shipment);
                break;
              }
            }
          })
          .addCase(addOrderShipment.rejected, (state, action) => {
            state.shipmentStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(updateOrderShipment.pending, (state) => {
            state.shipmentStatus = 'loading';
          })
          .addCase(updateOrderShipment.fulfilled, (state, action) => {
            state.shipmentStatus = 'succeeded';
            const { orderId, shipment } = action.payload || {};
            if (!orderId || !shipment) return;
            for (var i = 0; i < state.orders.length; i++) {
              if (state.orders[i].id === orderId) {
                const shipments = state.orders[i].order_shipments || [];
                for (var j = 0; j < shipments.length; j++) {
                  if (shipments[j].id === shipment.id) {
                    shipments[j] = shipment;
                    break;
                  }
                }
                break;
              }
            }
          })
          .addCase(updateOrderShipment.rejected, (state, action) => {
            state.shipmentStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(deleteOrderShipment.pending, (state) => {
            state.shipmentStatus = 'loading';
          })
          .addCase(deleteOrderShipment.fulfilled, (state, action) => {
            state.shipmentStatus = 'succeeded';
            const { orderId, shipmentId } = action.payload || {};
            if (!orderId || !shipmentId) return;
            for (var i = 0; i < state.orders.length; i++) {
              if (state.orders[i].id === orderId) {
                state.orders[i].order_shipments = (state.orders[i].order_shipments || [])
                  .filter(s => s.id !== shipmentId);
                break;
              }
            }
          })
          .addCase(deleteOrderShipment.rejected, (state, action) => {
            state.shipmentStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(uploadTrackingCsv.pending, (state) => {
            state.trackingUploadStatus = 'loading';
            state.trackingUploadResults = null;
            state.trackingUploadError = null;
          })
          .addCase(uploadTrackingCsv.fulfilled, (state, action) => {
            state.trackingUploadStatus = 'succeeded';
            state.trackingUploadResults = action.payload;
          })
          .addCase(uploadTrackingCsv.rejected, (state, action) => {
            state.trackingUploadStatus = 'failed';
            state.trackingUploadError = action.error.message || 'Upload failed';
          })
      }
  });

  export const { clearTrackingUpload } = ordersSlice.actions;

  export default ordersSlice.reducer;




